import { UPDATE_PARAMS } from './ActionTypes';
export const updateParams = params => ({
  type: UPDATE_PARAMS,
  params
});